module.exports = __webpack_public_path__ + "media/images/like-ffa92fc2c8f0a781d5ae9ffbecefa054.svg";